import { render, staticRenderFns } from "./HeroSelect.vue?vue&type=template&id=2d21e1dc&"
import script from "./HeroSelect.vue?vue&type=script&lang=js&"
export * from "./HeroSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports